'use strict';

import { Form } from '@lf/mwuikit/src/scripts/objects/form';
import { DistanceInputs } from '@lf/mwuikit/src/scripts/objects/distanceInputs';
import { RepeatableFieldset } from '@lf/mwuikit/src/scripts/objects/repeatableFieldset';

(function () {
    const formElement = document.getElementById('carbon-footprint-simulator-form');

    if (formElement) {
        const form = Form({ element: formElement });

        const totalFootprintBinding = formElement.querySelector('[data-binding="total-footprint"]');
        const totalTreesBinding = formElement.querySelector('[data-binding="total-trees"]');
        const transportTotalFootprintBinding = formElement.querySelector('[data-binding="transport-footprint"]');
        const habitationTotalFootprintBinding = formElement.querySelector('[data-binding="habitation-footprint"]');
        const consumptionTotalFootprintBinding = formElement.querySelector('[data-binding="consumption-footprint"]');

        const carKMSInputElements = formElement.querySelectorAll('input[name^="CarKMS"]');
        let carFootprints = [];
        let carTotalFootprint = 0;

        let metroTripsFieldsets = new Array();
        let metroTripsFootprints = [];
        let metroTripsTotalFootprint = 0;

        let busTripsFieldsets = new Array();
        let busTripsFootprints = [];
        let busTripsTotalFootprint = 0;

        let trainTripsFieldsets = new Array();
        let trainTripsFootprints = [];
        let trainTripsTotalFootprint = 0;

        let flightTripsFieldsets = new Array();
        let flightTripsFootprints = [];
        let flightTripsTotalFootprint = 0;

        let transportTotalFootprint = 0;

        const habitationAreaInputElement = formElement.querySelector('input[name=HabitationArea]');
        const habitationTotalOfPersonsInputElement = formElement.querySelector('input[name=HabitationTotalOfPersons]');
        const habitationEnergyCarbonFactorInputElements = formElement.querySelectorAll('input[type=radio][name=HabitationEnergyCarbonFactor]');
        let habitationEnergyCarbonFactor = formElement.querySelectorAll('input[type=radio][name=HabitationEnergyCarbonFactor]:checked')[0].value;
        let habitationTotalFootprint = 0;

        const iTHardwareExpenditureInputElement = formElement.querySelector('input[name=ITHardwareExpenditure]');
        const furnitureExpenditureInputElement = formElement.querySelector('input[name=FurnitureExpenditure]');
        const dietCarbonFootprintSelectElement = formElement.querySelector('select[name=DietCarbonFootprint]');
        let iTHardwareExpenditureFootprint = 0;
        let furnitureExpenditureFootprint = 0;
        let consumptionTotalFootprint = 0;

        const inputEvents = ['change', 'input'];

        function TripFieldset(params) {
            const context = params.context;
            const fieldsetElement = params.fieldsetElement;
            const tripFrequencyInputSelector = params.tripFrequencyInputSelector;
            const tripDepartureStationInputSelector = params.tripDepartureStationInputSelector;
            const tripArrivalStationInputSelector = params.tripArrivalStationInputSelector;
            let carbonFactor = params.carbonFactor;
            const carbonFactors = params.carbonFactors;
            const onChangeCallback = params.onChangeCallback;

            let tripFrequency = 0;
            let roundTripFootprint = 0;

            fieldsetElement.querySelector(tripFrequencyInputSelector).addEventListener('input', function () {
                tripFrequency = this.value;
                onChangeCallback(roundTripFootprint * tripFrequency);
            });

            const distanceInputs = new DistanceInputs({
                context: context,
                tripDepartureStationInputElement: fieldsetElement.querySelector(tripDepartureStationInputSelector),
                tripArrivalStationInputElement: fieldsetElement.querySelector(tripArrivalStationInputSelector),
                onChange: function (distance) {
                    if (typeof carbonFactors === 'object') {
                        for (const threshold in carbonFactors) {
                            carbonFactor = parseFloat(carbonFactors[threshold]);
                            if (distance < parseInt(threshold)) break;
                        }
                    }
                    roundTripFootprint = parseFloat((distance * 2 * parseFloat(carbonFactor)).toFixed(3));
                    onChangeCallback(roundTripFootprint * tripFrequency);
                }
            });

            return {
                element: fieldsetElement
            }
        }

        function updateTransportTotalFootprint() {
            transportTotalFootprint = carTotalFootprint + metroTripsTotalFootprint + busTripsTotalFootprint + trainTripsTotalFootprint + flightTripsTotalFootprint;
            transportTotalFootprintBinding.innerHTML = transportTotalFootprint.toLocaleString('fr-FR');
        }

        function updateHabitationTotalFootprint(area, totalOfPersons, energyCarbonFactor) {
            habitationTotalFootprint = (area && totalOfPersons && energyCarbonFactor) ? (area * energyCarbonFactor * 204) / totalOfPersons : 0;
            habitationTotalFootprintBinding.innerHTML = habitationTotalFootprint.toLocaleString('fr-FR');
        }

        function updateConsumptionTotalFootprint(iTHardwareExpenditureFootprint, furnitureExpenditureFootprint, dietFootprint) {
            consumptionTotalFootprint = iTHardwareExpenditureFootprint + furnitureExpenditureFootprint + dietFootprint;
            consumptionTotalFootprintBinding.innerHTML = consumptionTotalFootprint.toLocaleString('fr-FR');
        }

        function updateTotalFootprint() {
            const total = transportTotalFootprint + habitationTotalFootprint + consumptionTotalFootprint;
            totalFootprintBinding.innerHTML = total.toLocaleString('fr-FR');
            if (total > 0) {
                const trees = Math.ceil(total / 150);
                totalTreesBinding.innerHTML = (trees || 1).toLocaleString('fr-FR');
            } else {
                totalTreesBinding.innerHTML = 0;
            }
        }

        for (let i = 0; i < carKMSInputElements.length; i++) {
            carFootprints[i] = 0;

            carKMSInputElements[i].addEventListener('input', function () {
                if (this.dataset.carbonFactor) {
                    carFootprints[i] = this.dataset.carbonFactor * this.value;
                    carTotalFootprint = carFootprints.reduce((a, b) => a + b);
                    updateTransportTotalFootprint();
                    updateTotalFootprint();
                }
            });
        }

        const metroTripFieldsetElement = document.getElementById('metro-trip-fieldset');
        const metroCarbonFactor = metroTripFieldsetElement.dataset.carbonFactor;
        const metroTripsRepeatableFieldset = new TripFieldset({
            context: 'FRANCE',
            fieldsetElement: metroTripFieldsetElement,
            tripFrequencyInputSelector: 'input[name^="MetroTripFrequency"]',
            tripDepartureStationInputSelector: 'input[name^="MetroTripDepartureStation"]',
            tripArrivalStationInputSelector: 'input[name^="MetroTripArrivalStation"]',
            carbonFactor: metroCarbonFactor,
            onChangeCallback: function (footprint) {
                metroTripsFootprints[0] = footprint;
                metroTripsTotalFootprint = metroTripsFootprints.reduce((a, b) => a + b);
                updateTransportTotalFootprint();
                updateTotalFootprint();
            }
        });

        metroTripsFootprints[0] = 0;
        metroTripsFieldsets[0] = metroTripsRepeatableFieldset;

        const metroTripRepeatableFieldSet = new RepeatableFieldset({
            fieldsetElement: metroTripFieldsetElement,
            deleteFieldsetCtaSelector: '.delete-cta',
            ctaElement: document.getElementById('repeat-metro-trip-cta'),
            onRepeatCallback: function (element) {
                const index = metroTripsFieldsets.length;
                metroTripsFootprints[index] = 0;

                if (typeof element.dataset.repeatableFieldset !== 'undefined') {
                    metroTripsFieldsets.push(metroTripsRepeatableFieldset);
                } else {
                    metroTripsFieldsets.push(new TripFieldset({
                        context: 'FRANCE',
                        fieldsetElement: element,
                        tripFrequencyInputSelector: 'input[name^="MetroTripFrequency"]',
                        tripDepartureStationInputSelector: 'input[name^="MetroTripDepartureStation"]',
                        tripArrivalStationInputSelector: 'input[name^="MetroTripArrivalStation"]',
                        carbonFactor: metroCarbonFactor,
                        onChangeCallback: function (footprint) {
                            metroTripsFootprints[index] = footprint;
                            metroTripsTotalFootprint = metroTripsFootprints.reduce((a, b) => a + b);
                            updateTransportTotalFootprint();
                            updateTotalFootprint();
                        }
                    }));
                }
            },
            onDeleteCallback: function (element) {
                metroTripsFieldsets = metroTripsFieldsets.filter(function (fieldset, index) {
                    if (element !== fieldset.element) {
                        return fieldset;
                    } else {
                        metroTripsFootprints.splice(index, 1);
                        metroTripsTotalFootprint = metroTripsFootprints.length ? metroTripsFootprints.reduce((a, b) => a + b) : 0;
                        updateTransportTotalFootprint();
                        updateTotalFootprint();
                    }
                })
            }
        });

        const busTripFieldsetElement = document.getElementById('bus-trip-fieldset');
        const busCarbonFactor = busTripFieldsetElement.dataset.carbonFactor;
        const busTripsRepeatableFieldset = new TripFieldset({
            fieldsetElement: busTripFieldsetElement,
            tripFrequencyInputSelector: 'input[name^="BusTripFrequency"]',
            tripDepartureStationInputSelector: 'input[name^="BusTripDepartureStation"]',
            tripArrivalStationInputSelector: 'input[name^="BusTripArrivalStation"]',
            carbonFactor: busCarbonFactor,
            onChangeCallback: function (footprint) {
                busTripsFootprints[0] = footprint;
                busTripsTotalFootprint = busTripsFootprints.reduce((a, b) => a + b);
                updateTransportTotalFootprint();
                updateTotalFootprint();
            }
        });

        busTripsFootprints[0] = 0;
        busTripsFieldsets[0] = busTripsRepeatableFieldset;

        const busTripRepeatableFieldSet = new RepeatableFieldset({
            fieldsetElement: busTripFieldsetElement,
            deleteFieldsetCtaSelector: '.delete-cta',
            ctaElement: document.getElementById('repeat-bus-trip-cta'),
            onRepeatCallback: function (element) {
                const index = busTripsFieldsets.length;
                busTripsFootprints[index] = 0;

                if (typeof element.dataset.repeatableFieldset !== 'undefined') {
                    busTripsFieldsets.push(busTripsRepeatableFieldset);
                } else {
                    busTripsFieldsets.push(new TripFieldset({
                        fieldsetElement: element,
                        tripFrequencyInputSelector: 'input[name^="BusTripFrequency"]',
                        tripDepartureStationInputSelector: 'input[name^="BusTripDepartureStation"]',
                        tripArrivalStationInputSelector: 'input[name^="BusTripArrivalStation"]',
                        carbonFactor: busCarbonFactor,
                        onChangeCallback: function (footprint) {
                            busTripsFootprints[index] = footprint;
                            busTripsTotalFootprint = busTripsFootprints.reduce((a, b) => a + b);
                            updateTransportTotalFootprint();
                            updateTotalFootprint();
                        }
                    }));
                }
            },
            onDeleteCallback: function (element) {
                busTripsFieldsets = busTripsFieldsets.filter(function (fieldset, index) {
                    if (element !== fieldset.element) {
                        return fieldset;
                    } else {
                        busTripsFootprints.splice(index, 1);
                        busTripsTotalFootprint = busTripsFootprints.length ? busTripsFootprints.reduce((a, b) => a + b) : 0;
                        updateTransportTotalFootprint();
                        updateTotalFootprint();
                    }
                })
            }
        });

        const trainTripFieldsetElement = document.getElementById('train-trip-fieldset');
        const trainCarbonFactor = trainTripFieldsetElement.dataset.carbonFactor;
        const trainTripsRepeatableFieldset = new TripFieldset({
            fieldsetElement: trainTripFieldsetElement,
            tripFrequencyInputSelector: 'input[name^="TrainTripFrequency"]',
            tripDepartureStationInputSelector: 'input[name^="TrainTripDepartureStation"]',
            tripArrivalStationInputSelector: 'input[name^="TrainTripArrivalStation"]',
            carbonFactor: trainCarbonFactor,
            onChangeCallback: function (footprint) {
                trainTripsFootprints[0] = footprint;
                trainTripsTotalFootprint = trainTripsFootprints.reduce((a, b) => a + b);
                updateTransportTotalFootprint();
                updateTotalFootprint();
            }
        });

        trainTripsFootprints[0] = 0;
        trainTripsFieldsets[0] = trainTripsRepeatableFieldset;

        const trainTripRepeatableFieldSet = new RepeatableFieldset({
            fieldsetElement: trainTripFieldsetElement,
            deleteFieldsetCtaSelector: '.delete-cta',
            ctaElement: document.getElementById('repeat-train-trip-cta'),
            onRepeatCallback: function (element) {
                const index = trainTripsFieldsets.length;
                trainTripsFootprints[index] = 0;

                if (typeof element.dataset.repeatableFieldset !== 'undefined') {
                    trainTripsFieldsets.push(trainTripsRepeatableFieldset);
                } else {
                    trainTripsFieldsets.push(new TripFieldset({
                        fieldsetElement: element,
                        tripFrequencyInputSelector: 'input[name^="TrainTripFrequency"]',
                        tripDepartureStationInputSelector: 'input[name^="TrainTripDepartureStation"]',
                        tripArrivalStationInputSelector: 'input[name^="TrainTripArrivalStation"]',
                        carbonFactor: trainCarbonFactor,
                        onChangeCallback: function (footprint) {
                            trainTripsFootprints[index] = footprint;
                            trainTripsTotalFootprint = trainTripsFootprints.reduce((a, b) => a + b);
                            updateTransportTotalFootprint();
                            updateTotalFootprint();
                        }
                    }));
                }
            },
            onDeleteCallback: function (element) {
                trainTripsFieldsets = trainTripsFieldsets.filter(function (fieldset, index) {
                    if (element !== fieldset.element) {
                        return fieldset;
                    } else {
                        trainTripsFootprints.splice(index, 1);
                        trainTripsTotalFootprint = trainTripsFootprints.length ? trainTripsFootprints.reduce((a, b) => a + b) : 0;
                        updateTransportTotalFootprint();
                        updateTotalFootprint();
                    }
                })
            }
        });

        const flightTripFieldsetElement = document.getElementById('flight-trip-fieldset');
        const flightCarbonFactors = JSON.parse(flightTripFieldsetElement.dataset.carbonFactor);
        const flightTripsRepeatableFieldset = new TripFieldset({
            fieldsetElement: flightTripFieldsetElement,
            tripFrequencyInputSelector: 'input[name^="FlightTripFrequency"]',
            tripDepartureStationInputSelector: 'input[name^="FlightTripDepartureStation"]',
            tripArrivalStationInputSelector: 'input[name^="FlightTripArrivalStation"]',
            carbonFactors: flightCarbonFactors,
            onChangeCallback: function (footprint) {
                flightTripsFootprints[0] = footprint;
                flightTripsTotalFootprint = flightTripsFootprints.reduce((a, b) => a + b);
                updateTransportTotalFootprint();
                updateTotalFootprint();
            }
        });

        flightTripsFootprints[0] = 0;
        flightTripsFieldsets[0] = flightTripsRepeatableFieldset;

        const flightTripRepeatableFieldSet = new RepeatableFieldset({
            fieldsetElement: flightTripFieldsetElement,
            deleteFieldsetCtaSelector: '.delete-cta',
            ctaElement: document.getElementById('repeat-flight-trip-cta'),
            onRepeatCallback: function (element) {
                const index = flightTripsFieldsets.length;
                flightTripsFootprints[index] = 0;

                if (typeof element.dataset.repeatableFieldset !== 'undefined') {
                    flightTripsFieldsets.push(flightTripsRepeatableFieldset);
                } else {
                    flightTripsFieldsets.push(new TripFieldset({
                        fieldsetElement: element,
                        tripFrequencyInputSelector: 'input[name^="FlightTripFrequency"]',
                        tripDepartureStationInputSelector: 'input[name^="FlightTripDepartureStation"]',
                        tripArrivalStationInputSelector: 'input[name^="FlightTripArrivalStation"]',
                        carbonFactors: flightCarbonFactors,
                        onChangeCallback: function (footprint) {
                            flightTripsFootprints[index] = footprint;
                            flightTripsTotalFootprint = flightTripsFootprints.reduce((a, b) => a + b);
                            updateTransportTotalFootprint();
                            updateTotalFootprint();
                        }
                    }));
                }
            },
            onDeleteCallback: function (element) {
                flightTripsFieldsets = flightTripsFieldsets.filter(function (fieldset, index) {
                    if (element !== fieldset.element) {
                        return fieldset;
                    } else {
                        flightTripsFootprints.splice(index, 1);
                        flightTripsTotalFootprint = flightTripsFootprints.length ? flightTripsFootprints.reduce((a, b) => a + b) : 0;
                        updateTransportTotalFootprint();
                        updateTotalFootprint();
                    }
                })
            }
        });

        for (let i = 0; i < habitationEnergyCarbonFactorInputElements.length; i++) {
            habitationEnergyCarbonFactorInputElements[i].addEventListener('change', function () {
                if (this.checked) {
                    habitationEnergyCarbonFactor = parseFloat(this.value);
                    updateHabitationTotalFootprint(habitationAreaInputElement.value, habitationTotalOfPersonsInputElement.value, habitationEnergyCarbonFactor);
                    updateTotalFootprint();
                }
            });
        }

        for (let i = 0; i < inputEvents.length; i++) {
            habitationAreaInputElement.addEventListener(inputEvents[i], function () {
                if (this.value < 0) this.value = 0;
                updateHabitationTotalFootprint(this.value, habitationTotalOfPersonsInputElement.value, habitationEnergyCarbonFactor);
                updateTotalFootprint();
            });
        }

        for (let i = 0; i < inputEvents.length; i++) {
            habitationTotalOfPersonsInputElement.addEventListener(inputEvents[i], function () {
                if (this.value < 0) this.value = 0;
                updateHabitationTotalFootprint(habitationAreaInputElement.value, this.value, habitationEnergyCarbonFactor);
                updateTotalFootprint();
            });
        }

        dietCarbonFootprintSelectElement.addEventListener('change', function () {
            updateConsumptionTotalFootprint(iTHardwareExpenditureFootprint, furnitureExpenditureFootprint, parseFloat(this.value))
            updateTotalFootprint();
        });

        for (let i = 0; i < inputEvents.length; i++) {
            iTHardwareExpenditureInputElement.addEventListener(inputEvents[i], function () {
                if (this.dataset.carbonFactor) {
                    iTHardwareExpenditureFootprint = this.dataset.carbonFactor * this.value;
                }
                updateConsumptionTotalFootprint(iTHardwareExpenditureFootprint, furnitureExpenditureFootprint, parseFloat(dietCarbonFootprintSelectElement.value));
                updateTotalFootprint();
            });
        }

        for (let i = 0; i < inputEvents.length; i++) {
            furnitureExpenditureInputElement.addEventListener(inputEvents[i], function () {
                if (this.dataset.carbonFactor) {
                    furnitureExpenditureFootprint = this.dataset.carbonFactor * this.value;
                }
                updateConsumptionTotalFootprint(iTHardwareExpenditureFootprint, furnitureExpenditureFootprint, parseFloat(dietCarbonFootprintSelectElement.value));
                updateTotalFootprint();
            });
        }
    }
}());
